import { css } from "@emotion/react"
import React, { type ElementType } from "react"
import type { SpaceToken } from "../tokens"
import { cssVariables, tokenVar } from "../theme"
import type { PolymorphicProps } from "./polymorphic"

interface InlineOwnProps {
  readonly gap?: SpaceToken
  readonly align?: "stretch" | "start" | "center" | "end" | "baseline"
  readonly justify?:
    | "start"
    | "center"
    | "end"
    | "space-between"
    | "space-around"
    | "space-evenly"
  readonly wrap?: boolean
}

export type InlineProps<Component extends ElementType = "div"> =
  PolymorphicProps<Component, InlineOwnProps>

export const Inline = <Component extends ElementType = "div">({
  as,
  gap = "lg",
  align = "center",
  justify = "start",
  wrap = true,
  css: cssProp,
  ...props
}: InlineProps<Component>) => {
  const Element = as ?? "div"

  return (
    <Element
      css={[
        css`
          display: flex;
          flex-flow: row ${wrap ? "wrap" : "nowrap"};
          min-width: 0;
          gap: ${tokenVar(cssVariables.space[gap])};
          align-items: ${align};
          justify-content: ${justify};
        `,
        cssProp,
      ]}
      {...props}
    />
  )
}
